import { Injectable } from '@angular/core';
import { CustomCookieService } from './custom-cookie.service';
import { LoaderService } from './loader.service';
import { environment } from '../../../environments/environment';
import { ExternalCode } from '../common/classes';

@Injectable({
  providedIn: 'root'
})
export class HelpersService {

  constructor(
    private customCookieService: CustomCookieService,
    private loaderService: LoaderService
  ) { }

  public get getAPIurl(): string {
    let {production, bffApi} = environment;
    return production ? bffApi : '';
  }

  public navigateBackToOEM(code: ExternalCode): void {
    /// TODO: Ask siva about error defenition 
    const redirectUrl = this.customCookieService.getData('ui-redirect_uri', true)
    console.log('redirectUrl', redirectUrl)
    this.loaderService.show()
    window.location.assign(`${redirectUrl || 'com.bmw.connected://route/profile/esim'}?extErrorCode=${code}`);
    setTimeout(() => this.loaderService.hide(), 4000);
  }
}
